import { FC, useCallback, useContext } from 'react';
import { Link } from 'react-navi';

import { useTheme } from 'hooks/theme';
import { CommonUtilsContext } from 'contexts/commonUtils';

import { ScLogo } from './styled';
import { ImageComponent } from 'components/Image';

interface LogoProps {
  height?: number;
  mobHeight?: number;
  smallLogo?: boolean;
  onClick?: () => void;
}

export const Logo: FC<LogoProps> = ({ smallLogo, onClick, ...props }) => {
  const { menu } = useTheme();
  const { brandAssetsData } = useContext(CommonUtilsContext);

  const defaultLogo = smallLogo ? (
    <menu.logoSmall.component />
  ) : (
    <menu.logo.component />
  );

  const getCmsLogo = useCallback(() => {
    if (!brandAssetsData) return;

    const logoFromCms = smallLogo
      ? brandAssetsData?.logoMobile?.url
      : brandAssetsData?.logoDesktop?.url;

    if (!logoFromCms) return;

    return brandAssetsData?.animatedLogo ? (
      <object
        height={smallLogo ? '100%' : 34}
        width={smallLogo ? 48 : '100%'}
        data={logoFromCms}
        aria-label="Lucky Elf"
      />
    ) : (
      <ImageComponent
        src={logoFromCms}
        width={smallLogo ? 48 : '100%'}
        height={smallLogo ? '100%' : 34}
        alt="Lucky Elf"
      />
    );
  }, [brandAssetsData, smallLogo]);

  return (
    <ScLogo {...props}>
      <Link href="/" onClick={onClick} className="logo">
        {getCmsLogo() || defaultLogo}
      </Link>
    </ScLogo>
  );
};
